export const profile = {
  name: "Lindsey Anne Mayr",
  handle: "@explanthealer",
  title: "Explant Healer & Mentor",
  bio: "Explant survivor, Breast Implant Illness awareness coach and guide for women who want to reclaim their health.",
  avatarUrl:
    "https://customer-assets.emergentagent.com/job_follow-me-here/artifacts/raxx1hn1_IMGL4441-Edit-%20HIGH%20RES-PRINTING.jpg",
  links: [
    {
      id: "instagram",
      label: "Instagram",
      href: "https://www.instagram.com/explanthealer?igsh=MXZrbms3anJ1Y25mcA%3D%3D&utm_source=qr",
      type: "instagram",
    },
    {
      id: "facebook",
      label: "Facebook Group",
      href: "https://facebook.com/share/g/1AauoMTkW7/?mibextid=wwXIfr",
      type: "facebook",
    },
    {
      id: "tiktok",
      label: "TikTok",
      href: "https://www.tiktok.com/@explanthealer",
      type: "tiktok",
    },
    {
      id: "youtube",
      label: "YouTube Channel",
      href: "https://youtube.com/@Healingwomen?feature=shared",
      type: "youtube",
      highlight: true,
    },
    {
      id: "website",
      label: "Personal Website",
      href: "https://www.healing-women.com",
      type: "website",
    },
    {
      id: "phone",
      label: "Call / Text",
      href: "tel:+16047801466",
      type: "phone",
    },
    {
      id: "email",
      label: "Email",
      href: "mailto:lindsey@healing-women.com",
      type: "email",
    },
  ],
};
